import get from 'lodash/get';
import { createSelector } from 'reselect';

// Escalated tab filters
const getEscalatedTabFiltersObject = (state) => get(state, 'escalatedTabFilters', {});

export const getSelectedCommunicationTypeIdForEscalatedTabFilter = createSelector(
  getEscalatedTabFiltersObject,
  (escalatedTabFilters) => get(escalatedTabFilters, 'selectedCommunicationFilterId', 'all')
);

export const getSelectedBusinessesForEscalatedTabFilter = createSelector(
  getEscalatedTabFiltersObject,
  (escalatedTabFilters) => get(escalatedTabFilters, 'selectedBusinessForFilter.idList', [])
);

export const getExcludeSelectedBusinessesForEscalatedTabFilter = createSelector(
  getEscalatedTabFiltersObject,
  (escalatedTabFilters) => get(escalatedTabFilters, 'selectedBusinessForFilter.excludeBusinesses', false)
);

export const getEscalatedTabFilterParameters = createSelector(
  getSelectedCommunicationTypeIdForEscalatedTabFilter,
  getSelectedBusinessesForEscalatedTabFilter,
  getExcludeSelectedBusinessesForEscalatedTabFilter,
  (communicationTypeFilter, businessIdList, excludeBusinesses) => ({
    businessIdList,
    excludeBusinesses,
    communicationTypeFilter,
  })
);

// Escalated tab filters end
